<script setup lang="ts">
import type { TTimelineMobileQuickEntryPlacement } from '@/core/timeline/timeline.types';
import { computed } from 'vue';

const props = withDefaults(
  defineProps<{
    horizontalPadding?: boolean;
    mobilePlacement?: TTimelineMobileQuickEntryPlacement;
    verticalPadding?: boolean;
  }>(),
  {
    horizontalPadding: false,
    mobilePlacement: 'top',
    verticalPadding: true,
  },
);

const mobileDockClass: Record<TTimelineMobileQuickEntryPlacement, string> = {
  top: '',
  'navigation-dock':
    'max-md:fixed max-md:inset-x-0 max-md:bottom-mobile-navigation-offset max-md:top-auto max-md:z-40 max-md:px-md max-md:py-md',
  'viewport-dock':
    'max-md:fixed max-md:inset-x-0 max-md:bottom-0 max-md:top-auto max-md:z-40 max-md:px-md max-md:pb-mobile-safe-bottom-md max-md:pt-md',
};

const gradientClass = computed(() => [
  'bg-gradient-to-b from-surface-primary from-50% to-transparent',
  props.mobilePlacement !== 'top' && 'max-md:bg-gradient-to-t',
]);
</script>

<template>
  <div
    class="sticky top-0 z-50"
    :class="[
      props.horizontalPadding && 'px-content',
      props.verticalPadding && (props.mobilePlacement === 'top' ? '-my-md py-md' : 'md:-my-md md:py-md'),
      mobileDockClass[props.mobilePlacement],
      props.mobilePlacement !== 'top' && 'max-md:my-0',
      gradientClass,
    ]"
  >
    <slot></slot>
  </div>
</template>
